import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=c83a3eca&scoped=true"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"
import style0 from "./MessageView.vue?vue&type=style&index=0&id=c83a3eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83a3eca",
  null
  
)

export default component.exports